import { render, staticRenderFns } from "./DocumentsTab.vue?vue&type=template&id=7e01e0d2&scoped=true"
import script from "./DocumentsTab.vue?vue&type=script&lang=js"
export * from "./DocumentsTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentsTab.vue?vue&type=style&index=0&id=7e01e0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e01e0d2",
  null
  
)

export default component.exports